const CicleExclamationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="circle-exclamation 1" clipPath="url(#clip0_231_1279)">
        <path
          id="Vector"
          d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 18.75C5.17578 18.75 1.25 14.8242 1.25 10C1.25 5.17578 5.17578 1.25 10 1.25C14.8242 1.25 18.75 5.17578 18.75 10C18.75 14.8242 14.8242 18.75 10 18.75ZM10 11.875C10.3455 11.875 10.625 11.5955 10.625 11.25V5C10.625 4.65453 10.3455 4.375 10 4.375C9.65453 4.375 9.375 4.65625 9.375 5V11.25C9.375 11.5938 9.65625 11.875 10 11.875ZM10 13.4375C9.48242 13.4375 9.0625 13.8574 9.0625 14.375C9.0625 14.8926 9.48242 15.3125 10 15.3125C10.5176 15.3125 10.9375 14.8926 10.9375 14.375C10.9375 13.8574 10.5195 13.4375 10 13.4375Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_231_1279">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CicleExclamationIcon;
